import {SYS} from '@/config';

export default SYS == 'staff' ? [{  // 反馈编辑
	path: 'mine',
	meta: {
		title: '账号信息'
	},
	component: () => import('@/pages/home/mine')
}] : [{  // 反馈列表
	path: 'feedback',
	name: 'custom_complaints_proposals',
	meta: {
		title: '投诉建议',
		keepAlive: true
	},
	component: () => import('@/pages/client/feedback/list')
}, {  // 反馈编辑
	path: 'feedback/edit',
	meta: {
		title: '发布投诉建议'
	},
	component: () => import('@/pages/client/feedback/edit')
}, {  // 反馈编辑
	path: 'feedback/detail',
	meta: {
		title: '投诉建议详情'
	},
	props: route => route.query,
	component: () => import('@/pages/client/feedback/detail')
}, {  // 反馈编辑
	path: 'mine',
	meta: {
		title: '账号信息'
	},
	component: () => import('@/pages/home/mine')
}, {  // 用户协议
	path: 'agreement',
	meta: {
		title: '用户隐私服务协议',
		meta: {
			loginFree: true
		}
	},
	component: () => import('@/pages/home/agreement')
}];